import { useCallback, useEffect, useRef, useState } from "react";

export default function useToast() {
  const [toasts, setToasts] = useState([]);
  const timersRef = useRef(new Map());

  const removeToast = useCallback((id) => {
    const timeoutId = timersRef.current.get(id);

    if (timeoutId) {
      window.clearTimeout(timeoutId);
      timersRef.current.delete(id);
    }

    setToasts((current) => current.filter((toast) => toast.id !== id));
  }, []);

  const showToast = useCallback((message, isError = false, duration = 4000) => {
    const id = `${Date.now()}-${Math.random().toString(16).slice(2)}`;

    setToasts((current) => [
      ...current,
      {
        id,
        message,
        isError,
      },
    ]);

    const timeoutId = window.setTimeout(() => {
      removeToast(id);
    }, duration);

    timersRef.current.set(id, timeoutId);

    return id;
  }, [removeToast]);

  useEffect(() => {
    const timers = timersRef.current;

    return () => {
      timers.forEach((timeoutId) => {
        window.clearTimeout(timeoutId);
      });
      timers.clear();
    };
  }, []);

  return {
    toasts,
    showToast,
    removeToast,
  };
}
